// @NOTE-CH: Shouldn't this come from the utils/constants.ts file?
import { DonationProvider } from '@joindeed/calculate-fees';

export const getDonationProviderDisplayName = (donationProvider?: DonationProvider | null) => {
  const DonationProviderDisplayNameMap = new Map<keyof typeof DonationProvider, string>([
    [DonationProvider.Betterplace, DonationProvider.Betterplace],
    [DonationProvider.GiveIndia, DonationProvider.GiveIndia],
    [DonationProvider.NFG, 'Network For Good'],
    [DonationProvider.PayPal, DonationProvider.PayPal],
    [DonationProvider.Stripe, DonationProvider.Stripe],
    [DonationProvider.GlobalGiving, DonationProvider.GlobalGiving],
    [DonationProvider.DCGF, DonationProvider.DCGF],
  ]);

  return DonationProviderDisplayNameMap.get(donationProvider!);
};
